/*
 * ONE masking helper for both recorders (M3).
 *
 * Hotjar's loader for site 3674471 also runs Contentsquare's tag (Hotjar is
 * part of Contentsquare). Hotjar honours `data-hj-suppress`; Contentsquare's
 * own masking attribute is `data-cs-mask`, and nothing in this repo shows that
 * Contentsquare honours Hotjar's. So everything that is masked carries BOTH,
 * and nothing sets one without the other:
 *
 *   - JSX:  <Box {...REPLAY_MASK}>…</Box>
 *   - DOM:  maskElement(el) / unmaskElement(el)
 *
 * session-replay.js also mirrors any element that still carries only
 * `data-hj-suppress` (the older JSX) while a recording runs.
 */
export const HOTJAR_MASK_ATTR = "data-hj-suppress";
export const CONTENTSQUARE_MASK_ATTR = "data-cs-mask";
export const REPLAY_MASK_ATTRS = Object.freeze([HOTJAR_MASK_ATTR, CONTENTSQUARE_MASK_ATTR]);

// Spread onto a JSX element: both attributes, present and empty.
export const REPLAY_MASK = Object.freeze({
  [HOTJAR_MASK_ATTR]: "",
  [CONTENTSQUARE_MASK_ATTR]: "",
});

// Idempotent: an attribute already present is not written again. Writing it
// again would queue another mutation record, and the masking observer
// (session-replay.js) watches these attributes, so a non-idempotent write would
// loop forever.
export const maskElement = (el) => {
  if (!el || typeof el.setAttribute !== "function") return;
  REPLAY_MASK_ATTRS.forEach((attr) => {
    if (typeof el.hasAttribute !== "function" || !el.hasAttribute(attr)) el.setAttribute(attr, "");
  });
};

export const unmaskElement = (el) => {
  if (!el || typeof el.removeAttribute !== "function") return;
  REPLAY_MASK_ATTRS.forEach((attr) => el.removeAttribute(attr));
};

export const isMasked = (el) => Boolean(el)
  && typeof el.hasAttribute === "function"
  && REPLAY_MASK_ATTRS.every((attr) => el.hasAttribute(attr));
